module.exports = __webpack_public_path__ + "img/pap.d536ae24.svg";